import styles from './index.less';
import userUrl from '@/assets/global/User@2x.png';
import userActiveUrl from '@/assets/global/userActived.png';
import homeUrl from '@/assets/global/Home@2x.png';
import homeActiveUrl from '@/assets/global/homeActived.png';
import { useEffect, useState } from 'react';
import { history } from '@umijs/max';

import servicesUrl from '@/assets/global/serve.png'
import servicesActivedUrl from '@/assets/global/serveActived.png';

type BottomNavItemListType = {
  label: string;
  icon: string;
  path: string;
  key: string;
};

interface StickyBottomProps {
  activeKey: string;
}

const StickyBottom = ({ activeKey }: StickyBottomProps) => {
  const defaultBottomNavItemList: BottomNavItemListType[] = [
    {
      label: '首页',
      icon: homeActiveUrl,
      path: '/',
      key: 'home',
    },
    {
      label: '服务',
      icon: servicesUrl,
      path: '/servicesMore',
      key: 'services',
    },
    {
      label: '我的',
      icon: userUrl,
      path: '/user',
      key: 'user',
    },
  ];
  const toggleBottomNavItemList: BottomNavItemListType[] = [
    {
      label: '首页',
      icon: homeUrl,
      path: '/',
      key: 'home',
    },
    {
      label: '服务',
      icon: servicesUrl,
      path: '/servicesMore',
      key: 'services',
    },
    {
      label: '我的',
      icon: userActiveUrl,
      path: '/user',
      key: 'user',
    },
  ];

  const toggleBottomServeNavItemList: BottomNavItemListType[] = [
    {
      label: '首页',
      icon: homeUrl,
      path: '/',
      key: 'home',
    },
    {
      label: '服务',
      icon: servicesActivedUrl,
      path: '/servicesMore',
      key: 'services',
    },
    {
      label: '我的',
      icon: userUrl,
      path: '/user',
      key: 'user',
    },
  ];

  const [activeIndex, setActiveIndex] = useState('home');
  const [navItemList, setNavItemList] = useState<BottomNavItemListType[]>(
    defaultBottomNavItemList,
  );

  useEffect(() => {
    setActiveIndex(activeKey);
  }, [activeKey]);

  useEffect(() => {
    if (activeIndex === 'user') {
      setNavItemList(toggleBottomNavItemList);
    } else if (activeIndex === 'services'){
      setNavItemList(toggleBottomServeNavItemList);
    } else {
      setNavItemList(defaultBottomNavItemList);
    }
  }, [activeIndex]);

  const handlerChange = (item: BottomNavItemListType) => {
    setActiveIndex(item.key);
    history.push(item.path);
  };

  return (
    <div className={styles['bottom-navigation']}>
      {navItemList.map((item) => (
        <div onClick={() => handlerChange(item)} key={item.label}>
          <img src={item.icon} alt={item.label} />
          <p
            className={
              activeIndex === item.key ? styles.active : styles.default
            }
          >
            {item.label}
          </p>
        </div>
      ))}
    </div>
  );
};

export default StickyBottom;
